<template lang="pug">
  #app
    event-detail
    sprite-detail
    event-create
    b-navbar(toggleable='md', type='light', v-if='!shouldHideNav')
      .container
        b-navbar-toggle(target='nav_collapse')
        b-navbar-brand(:to='{name: "LandingPage"}', v-if='onLogingPage')
          img.logo(src='./assets/logo@3x.png')
        b-navbar-brand(:to='{name: "Home"}', v-else)
          img.logo(src='./assets/logo@3x.png')
        b-collapse#nav_collapse(is-nav='', v-if='!onLogingPage')
          b-navbar-nav
            b-nav-item(:to='{name: "Home"}', :active='$route.name === "Home"') Dashboard
            b-nav-item(:to='{name: "MySprites"}', :active='$route.name === "MySprites"') My Sprites
            b-nav-item(:to='{name: "Market"}', :active='$route.name === "Market"') Marketplace
            b-nav-item(:to='{name: "FAQ"}', :active='$route.name === "FAQ"') FAQ
          b-navbar-nav.ml-auto
            recomendations
            notifications-item
            b-tooltip(target="userSettings", title="User and Settings", triggers="hover")
            b-nav-item-dropdown.user-nav(right='')
              template(slot='button-content')
                img#userSettings(src='./assets/nav/user.svg')
              b-dropdown-item.sub-item(v-if='user', @click='copyUserID()') UserID: {{ user._id }}
                input(type="hidden", id="copy-user", :value="user._id")
              // b-dropdown-item.sub-item(href='#') Profile
              b-dropdown-item.sub-item(href='#', @click.prevent='logout()') Signout
    notifications(group="main", style='top: 80px;', class="custom-noitification")
      template(slot='body', scope='props')
        .notif-wrap.d-flex.align-items-center
          .icon.d-flex.align-items-center.justify-content-center
            img(src='./assets/achievement.svg')
          .details
            .title {{ props.item.title }}
            .text(v-html='props.item.text')
          a.close(@click='props.close')
            span x
    router-view
    footer.container
      .border
      .row
        .col-12.col-md-6
          .float-left © HabitRPG 2018. All rights reserved.
        .col-12.col-md-6
          .float-right
            a Privacy Policy
            a Terms of Service
</template>

<script>
import axios from 'axios';

import EventDetail from './components/events/EventDetail';
import EventCreate from './components/events/EventCreate';
import SpriteDetail from './components/monsters/SpriteDetail';
import Recomendations from './components/nav/Recomendations';
import NotificationsItem from './components/nav/Notifications';

import SocketMixin from './mixins/socketio';

export default {
  name: 'App',
  components: {
    Recomendations,
    NotificationsItem,
    EventDetail,
    EventCreate,
    SpriteDetail,
  },
  data() {
    return {
      githubTimer: null,
    };
  },
  mixins: [SocketMixin],
  mounted() {
    this.$root.$on('sprite:loadUserDetails', this.loadUserDetails);

    const storedUser = localStorage.getItem('habitica-token-user');
    if (!storedUser) return;
    this.loadUserDetails();
  },
  destroyed() {
    this.$root.$off('sprite:loadUserDetails');
    clearInterval(this.githubTimer);
  },
  methods: {
    async loadUserDetails() {
      this.$store.state.loading = true;
      // @TODO: Combine these into one route?

      this.$store.state.events = await this.$store.dispatch('getEvents');
      await this.$store.dispatch('getIntegrations');

      // @TODO: Move to store
      const response = await axios.get('/me');
      const user = response.data.data;
      this.$store.state.user = user;
      window.amplitude.setUserId(user._id);

      if (user && user.selectedMonster) {
        this.$set(this.$store.state, 'favoriteMonster', {
          name: user.selectedMonster,
        });
      }

      if (user && user.monster) {
        this.$set(this.$store.state, 'favoriteMonster', user.monster);
      }

      // @TODO: Combine with me url?
      if (this.providers.Github) {
        await axios.get('/integrations/github-activity');
        this.githubTimer = setInterval(() => { axios.get('/integrations/github-activity'); }, 10000);
      }

      // if (this.providers.Todoist) {
      //   await axios.get('/integrations/todoist-activity');
      // }

      this.$store.state.loading = false;
    },
    logout() {
      localStorage.setItem('habitica-token-user', '');
      window.location.href = '/';
    },
    copyUserID() {
      const testingCodeToCopy = document.querySelector('#copy-user');
      testingCodeToCopy.setAttribute('type', 'text');
      testingCodeToCopy.select();

      try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successfully' : 'unsuccessful';
        alert(`User ID was copied ${msg}`);
      } catch (err) {
        alert('Oops, unable to copy');
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
    },
  },
  computed: {
    providers() {
      return this.$store.state.integrations;
    },
    shouldHideNav() {
      return this.$route.name === 'LandingPage';
    },
    onLogingPage() {
      return this.$route.name === 'HabiticaLogin';
    },
    user() {
      return this.$store.state.user;
    },
  },
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Nunito:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i');

  body {
    background-color: #f7f8f6 !important;
  }

  #app {
    font-family: 'Nunito', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    overflow: hidden;
    min-height: 100vh;
  }

  .navbar {
    background: #fff;
    padding: 0 !important;
    box-shadow: 0 2px 2px 0 rgba(31, 31, 31, 0.12), 0 0 2px 0 rgba(31, 31, 31, 0.12);

    .navbar-collapse {
      height: 80px;
    }

    .navbar-nav {
      height: 100%;

      .nav-item {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
      }
    }
  }

  .navbar-nav {
    margin-left: 3em;
  }

  .nav-item {
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: 1px;
    text-align: center;
    color: #6c6d69;
    text-transform: uppercase;
    margin-right: 1em;
  }

  .nav-item .active {
    color: #363734;
    font-weight: bold;
  }

  .nav-item .active::after {
    position: absolute;
    left: 0;
    content: '';
    width: 100%;
    display: block;
    bottom: -1px;
    height: 8px;
    background: #9bc75a;
    border-radius: 4px 4px 0 0;
    background:  linear-gradient(to right, #9bc75a, #3ba5a8);
  }

  @media (max-width: 575.98px) {
    .navbar {
      padding: 0.5rem 1rem !important;
    }

    #nav_collapse {
      height: auto;
    }
  }

  .logo {
    width: 94.3px;
  }

  .sub-item {
    text-transform: none;
    font-size: 12px;
  }

  .sub-item:hover, .sub-item:focus {
    border: none;
  }

  .user-nav .dropdown-toggle::after {
    border: none !important;
  }

  /* Custom Notifications */
  .custom-noitification {
    text-align: left;

    .notification-wrapper {
      margin-bottom: .5rem;
    }

    .notif-wrap {
      background: #363734;
      padding: .5rem 1rem;
      border-radius: 8px;
      margin-right: 1rem;
      height: 68px;
    }

    .icon {
      width: 48px;
      height: 48px;
      border-radius: 4px;
      background-color: #e7e9e4;
    }

    .details {
      margin-left: .5rem;
    }

    .title {
      font-size: 14px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #ffffff;
    }

    .text {
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      color: #e7e9e4;
    }

    .close {
      height: 48px;
      margin-left: 1rem;

      span {
        display: block;
        color: #e7e9e4;
        text-shadow: none;
        font-size: 16px;
        height: 16px;
      }
    }
  }

  /* Buttons */
  .btn-green {
    text-transform: uppercase;
    padding: .5em 1.4em;
    border-radius: 999px;
    background: linear-gradient(to right, #9bc75a, #3ba5a8);
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: 1px;
    text-align: center;
    color: #f7f8f6;
  }

  .btn-green:hover {
    cursor: pointer;
    color: #ffffff;
    box-shadow: 0 2px 2px 0 rgba(31, 31, 31, 0.12), 0 0 2px 0 rgba(31, 31, 31, 0.12);
  }

  .btn-green:active {
    color: #ffffff;
    box-shadow: inset 0 0 0 2px rgba(54, 55, 52, 0.12);
  }

  .btn-blue {
    text-transform: uppercase;
    padding: .5em 1.4em;
    border-radius: 999px;
    background-color: #3ba5a8;
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: 1px;
    text-align: center;
    color: #f7f8f6;
  }

  .btn-blue:hover {
    cursor: pointer;
    color: #ffffff;
    box-shadow: 0 2px 2px 0 rgba(31, 31, 31, 0.12), 0 0 2px 0 rgba(31, 31, 31, 0.12);
  }

  .btn-blue:active {
    color: #ffffff;
    border: solid 2px rgba(54, 55, 52, 0.12);
  }

  .btn-red {
    text-transform: uppercase;
    padding: .5em 1.4em;
    border-radius: 999px;
    background-color: #e14455;
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: 1px;
    text-align: center;
    color: #f7f8f6;
  }

  .btn-red:hover {
    cursor: pointer;
    color: #ffffff;
    box-shadow: 0 2px 2px 0 rgba(31, 31, 31, 0.12), 0 0 2px 0 rgba(31, 31, 31, 0.12);
  }

  .btn-red:active {
    color: #ffffff;
    border: solid 2px rgba(54, 55, 52, 0.24);
  }

  .btn-disabled {
    background-color: #a1a39e;
    color: #e7e9e4;
  }

  /* Dropdown */
  .dropdown-component .dropdown-toggle {
    padding: .5em 1.4em;
    border-radius: 999px;
    background-color: #ffffff;
    border: solid 2px rgba(54, 55, 52, 0.08);
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #6c6d69 !important;
  }

  .dropdown-component .dropdown-toggle:after {
    border: none !important;
    display: inline-block;
    content: "";
    width: 10px;
    height: 6px;
    background: url('./assets/down-arrow-grey.svg') no-repeat;
    background-position: center;
    vertical-align: middle;
    margin-left: .8rem;
  }

  .dropdown-component .dropdown-toggle:hover:after {
    background: url('./assets/down-arrow.svg') no-repeat;
  }

  .dropdown-component .dropdown-toggle:hover {
    box-shadow: 0 2px 2px 0 rgba(31, 31, 31, 0.12), 0 0 2px 0 rgba(31, 31, 31, 0.12);
    background-color: #ffffff;
    border: solid 2px rgba(54, 55, 52, 0.08);
  }

  .dropdown-component .dropdown-toggle:active, .dropdown-component .dropdown-toggle:focus, .show > .btn-secondary.dropdown-toggle {
    background-color: #ffffff !important;
    border: solid 2px rgba(54, 55, 52, 0.24) !important;
    box-shadow: none !important;
  }

  .dropdown-component .dropdown-menu {
    border-radius: 8px;
    border: none;
    background-color: #ffffff;
    box-shadow: 0 4px 8px 0 rgba(31, 31, 31, 0.16), 0 4px 8px 0 rgba(31, 31, 31, 0.24);
  }

  .dropdown-component .dropdown-menu button {
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #6c6d69 !important;
  }

  .dropdown-component .dropdown-menu button:hover {
    background-color: #f7f8f6;
    color: #363734 !important;
    cursor: pointer;
  }

  .dropdown-component .dropdown-menu button:focus {
    box-shadow: none !important;
    border: none !important;
    outline: none !important;
  }

  .dropdown-component .dropdown-menu button:active, .dropdown-component .dropdown-menu .active {
    color: #9bc75a !important;
    box-shadow: none !important;
  }

  .dropdown-component .dropdown-menu button:active:after, .dropdown-component .dropdown-menu .active:after {
    content:  "";
    display: inline-block;
    width: 8px;
    height: 5px;
    margin-left: .8rem;
    background: url('./assets/checkmark.svg') no-repeat;
    background-position: center;
    vertical-align: middle;
  }

  /* Card wrappers */
  .card-wrap {
    width: 432px;
    margin: 0 auto;
    position: relative;
    border-radius: 16px;
    box-shadow: 0 4px 8px 0 rgba(31, 31, 31, 0.16), 0 4px 8px 0 rgba(31, 31, 31, 0.24);
    background-color: #ffffff;
    border: solid 2px #3ba5a8;
    padding: 2rem 3rem;

    .compass {
      position: absolute;
      top: -14px;
      right: -8px;
    }

    h3 {
      font-size: 16px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      color: #363734;
    }

    p {
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #6c6d69;
      margin: 0 auto;
      margin-top: 1rem;
      margin-bottom: 2rem;
      max-width: 588px;
    }
  }

  /* Tabs */
  .tabs {
    .tab {
      padding: .5em 1.5em;
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: 1px;
      text-align: center;
      color: #363734;
      text-transform: uppercase;
    }

    .tab:hover {
      cursor: pointer;
    }

    .tab.active {
      font-weight: bold;
    }

    .tab::after {
      content: '';
      height: 4px;
      display: block;
    }

    .tab.active::after, .tab:hover::after {
      width: 100%;
      border-radius: 999px;
      background-image: linear-gradient(to right, #9bc75a, #3ba5a8);
      border-radius: 8px;
    }
  }
</style>

<style scoped>
  footer {
    margin-top: 2rem;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #a1a39e;
    padding-bottom: 4em;
  }

  footer a {
    text-transform: uppercase;
    font-size: 16px;
    font-weight: bold;
    margin-left: 1em;
  }

  .border {
    border: solid 2px #e7e9e4;
    margin-bottom: 2em;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue